<template>
  <div class="column-box">
    <div class="column-left">
      <div class="column-logo"><img src="../../img/Frame525.svg" alt=""></div>
      <div class="column-title">
        <div class="column-title-container">
          <div class="main-column" :class="mainNum == 0 ? 'mainShow' : ''" @click="main($event)">主栏目</div>
          <div class="xian">
            <div class="title-square"></div>
          </div>
          <div class="sub-column" :class="mainNum == 1 ? 'mainShow' : ''" @click="sub($event)">副栏目</div>

        </div>
      </div>
      <div class="column-menu-box">
        <div class="column-menu" @mouseenter="tipsOut()" @mouseleave="tipsLeave()">
          <img src="../../img/全部 7.svg" alt="" class="quanbu">
          <div class="column-menu-tips" v-show="tipsShow">
            <div class="tips-container">
              <div class="column-phone"><svg t="1679379500413" class="icon" viewBox="0 0 1061 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4276">
                  <path
                    d="M851.816296 296.77037c-11.757037-94.814815-78.772148-139.794963-145.180444-144.763259-30.189037-2.275556-55.068444 7.774815-73.234963 30.72-7.736889 9.746963-15.511704 28.709926-25.182815 58.254222-2.806519 8.571259-5.688889 17.863111-8.722963 27.83763a2018.266074 2018.266074 0 0 0-20.973037 75.245037l-1.85837 7.168-3.185778 12.515556 8.912593 9.291851 52.641185 54.613334c-33.829926 67.963259-92.273778 129.517037-152.462223 155.496296l-44.828444-45.549037-8.267852-8.419556-11.491555 2.048-7.205926 1.327408-18.962963 3.565037c-19.607704 3.754667-39.215407 7.698963-57.571556 11.681185-13.160296 2.88237-25.220741 5.688889-35.915852 8.343704-21.541926 5.423407-36.939852 10.24-46.269629 14.791111-34.133333 16.914963-47.597037 53.020444-42.36326 98.190222 7.509333 64.777481 75.58637 138.695111 159.516445 139.567408 93.828741 0.986074 225.507556-69.025185 318.577778-168.997926 112.109037-120.338963 176.545185-241.208889 163.991703-342.926223z"
                    p-id="4277" fill="#ffffff"></path>
                </svg>
                <svg t="1679379500413" class="icon" viewBox="0 0 1061 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4276">
                  <path
                    d="M851.816296 296.77037c-11.757037-94.814815-78.772148-139.794963-145.180444-144.763259-30.189037-2.275556-55.068444 7.774815-73.234963 30.72-7.736889 9.746963-15.511704 28.709926-25.182815 58.254222-2.806519 8.571259-5.688889 17.863111-8.722963 27.83763a2018.266074 2018.266074 0 0 0-20.973037 75.245037l-1.85837 7.168-3.185778 12.515556 8.912593 9.291851 52.641185 54.613334c-33.829926 67.963259-92.273778 129.517037-152.462223 155.496296l-44.828444-45.549037-8.267852-8.419556-11.491555 2.048-7.205926 1.327408-18.962963 3.565037c-19.607704 3.754667-39.215407 7.698963-57.571556 11.681185-13.160296 2.88237-25.220741 5.688889-35.915852 8.343704-21.541926 5.423407-36.939852 10.24-46.269629 14.791111-34.133333 16.914963-47.597037 53.020444-42.36326 98.190222 7.509333 64.777481 75.58637 138.695111 159.516445 139.567408 93.828741 0.986074 225.507556-69.025185 318.577778-168.997926 112.109037-120.338963 176.545185-241.208889 163.991703-342.926223z"
                    p-id="4277" fill="#728EC1"></path>
                </svg>
              </div>
              <div class="column-information"><svg t="1679380253963" class="icon" viewBox="0 0 1061 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4518">
                  <path
                    d="M852.726519 309.096296l-326.01126 188.188445-317.857185-183.561482A92.084148 92.084148 0 0 1 300.714667 227.555556h460.496592c47.29363 0 86.319407 35.574519 91.51526 81.54074z m0.606814 67.394371v286.492444a92.122074 92.122074 0 0 1-92.16 92.122074H300.752593a92.122074 92.122074 0 0 1-92.16-92.16v-281.6l303.597037 175.29363a29.430519 29.430519 0 0 0 32.085333-1.782519c0.417185-0.18963 0.758519-0.455111 1.175704-0.682666L853.333333 376.490667z"
                    p-id="4519" fill="#ffffff"></path>
                </svg>
                <svg t="1679380845217" class="icon" viewBox="0 0 1061 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="12948" width="200" height="200">
                  <path
                    d="M852.726519 309.096296l-326.01126 188.188445-317.857185-183.561482A92.084148 92.084148 0 0 1 300.714667 227.555556h460.496592c47.29363 0 86.319407 35.574519 91.51526 81.54074z m0.606814 67.394371v286.492444a92.122074 92.122074 0 0 1-92.16 92.122074H300.752593a92.122074 92.122074 0 0 1-92.16-92.16v-281.6l303.597037 175.29363a29.430519 29.430519 0 0 0 32.085333-1.782519c0.417185-0.18963 0.758519-0.455111 1.175704-0.682666L853.333333 376.490667z"
                    p-id="12949" fill="#728EC1"></path>
                </svg>
              </div>
              <div class="column-address"><svg t="1679380343584" class="icon" viewBox="0 0 1061 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4910">
                  <path
                    d="M530.962963 151.703704a325.973333 325.973333 0 0 1 228.314074 92.425481c109.226667 106.382222 125.041778 276.404148 38.456889 399.777185a321.34637 321.34637 0 0 1-143.928889 113.739852l-102.855111 102.513778a29.50637 29.50637 0 0 1-39.860148 0.379259l-0.379259-0.379259-0.227556-0.417185-102.437926-102.096593a316.833185 316.833185 0 0 1-143.511704-113.739852C177.493333 520.571259 193.34637 350.511407 302.610963 244.129185A326.011259 326.011259 0 0 1 530.925037 151.703704z m0 155.799703a164.446815 164.446815 0 0 0-114.688 46.345482 155.951407 155.951407 0 0 0-47.521185 111.80563c0 43.387259 18.280296 83.057778 47.521185 111.653925a163.915852 163.915852 0 0 0 114.612148 46.497186 163.00563 163.00563 0 0 0 114.536296-46.573037 155.154963 155.154963 0 0 0 47.748741-111.616 155.268741 155.268741 0 0 0-47.786667-111.767704 163.498667 163.498667 0 0 0-114.49837-46.383408l0.075852 0.037926z"
                    p-id="4911" fill="#ffffff"></path>
                </svg>
                <svg t="1679380343584" class="icon" viewBox="0 0 1061 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="4910">
                  <path
                    d="M530.962963 151.703704a325.973333 325.973333 0 0 1 228.314074 92.425481c109.226667 106.382222 125.041778 276.404148 38.456889 399.777185a321.34637 321.34637 0 0 1-143.928889 113.739852l-102.855111 102.513778a29.50637 29.50637 0 0 1-39.860148 0.379259l-0.379259-0.379259-0.227556-0.417185-102.437926-102.096593a316.833185 316.833185 0 0 1-143.511704-113.739852C177.493333 520.571259 193.34637 350.511407 302.610963 244.129185A326.011259 326.011259 0 0 1 530.925037 151.703704z m0 155.799703a164.446815 164.446815 0 0 0-114.688 46.345482 155.951407 155.951407 0 0 0-47.521185 111.80563c0 43.387259 18.280296 83.057778 47.521185 111.653925a163.915852 163.915852 0 0 0 114.612148 46.497186 163.00563 163.00563 0 0 0 114.536296-46.573037 155.154963 155.154963 0 0 0 47.748741-111.616 155.268741 155.268741 0 0 0-47.786667-111.767704 163.498667 163.498667 0 0 0-114.49837-46.383408l0.075852 0.037926z"
                    p-id="4911" fill="#728EC1"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="column-banner" v-show="columnShow" @mouseleave="mainLeave()" @mouseenter="mainEnter()">
      <div class="column-banner-main" @mouseenter="bannerEnter(0)" @mouseLeave="bannerLeave(0)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>关于正熙</span>
            <p>About</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[0]" @click=click(i)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(1)" @mouseLeave="bannerLeave(1)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>产品中心</span>
            <p>Products</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[1]" @click=click2(i.title)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(2)" @mouseLeave="bannerLeave(2)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>学术园地</span>
            <p>academic</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[2]" @click=click(i)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(3)" @mouseLeave="bannerLeave(3)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>资讯信息</span>
            <p>news</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[3]" @click=click(i)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(4)" @mouseLeave="bannerLeave(4)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>加入我们</span>
            <p>join us</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[6]" @click=click(i)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="columnHover" v-show="columnHoverShow">

      </div>
    </div>
    <div class="column-banner" v-show="!columnShow" @mouseleave="mainLeave()" @mouseenter="mainEnter()">
      <div class="column-banner-main" @mouseenter="bannerEnter(0)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>定制服务</span>
            <p>Customize</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[4]" @click=click(i)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(1)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>会员中心</span>
            <p>Member</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in navigationList[5]" @click=click(i)>{{ i.title }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(2)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>购物指南</span>
            <p>Guide</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in footerList[1]" @click=click(i)>{{ i.name }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(3)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>配送政策</span>
            <p>Hot Products</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in footerList[2]" @click=click(i)>{{ i.name }}</div>
          </div>
        </div>
      </div>
      <div class="column-banner-main" @mouseenter="bannerEnter(4)">
        <div class="column-banner-container">
          <div class="column-text">
            <span>售后服务</span>
            <p>Hot Products</p>
          </div>
          <div class="c-t-c-b" v-show=ctshow>
            <div v-for="(i, index) in footerList[3]" @click=click(i)>{{ i.name }}</div>
          </div>
        </div>
      </div>
      <div class="columnHover" v-show="columnHoverShow">

      </div>
    </div>
    <div class="column-right">
      <div class="column-t">
        <div class="column-t-container" @click="close()">
          <svg t="1678158078389" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="6841">
            <path
              d="M813.653333 802.986667a42.666667 42.666667 0 0 1-60.373333 0L512 561.706667 270.72 802.986667a42.666667 42.666667 0 1 1-60.373333-60.373334L451.626667 501.333333 210.346667 260.053333a42.666667 42.666667 0 0 1 30.293333-72.746666 42.666667 42.666667 0 0 1 30.08 12.373333L512 440.96 753.28 199.68a42.666667 42.666667 0 0 1 72.746667 30.293333 42.666667 42.666667 0 0 1-12.373334 30.08L572.373333 501.333333l241.28 241.28a42.666667 42.666667 0 0 1 0 60.373334z"
              p-id="6842" fill="#ffffff"></path>
          </svg>
        </div>
      </div>
      <div class="column-r">
        <div class="column-r-t" :class="mainNum2 == 0 ? 'mainShow2' : ''" @click.stop="contraction($event)">
          展开
          <div class="contraction">-</div>
        </div>
        <div class="youxian">
          <div class="youkuai"></div>
        </div>
        <div class="column-r-b" :class="mainNum2 == 1 ? 'mainShow2' : ''" @click.stop="expansion($event)">
          收缩
          <div class="contraction">+</div>
        </div>
      </div>
      <div class="column-b">
        <div class="column-b-t">
          <div class="login" @click="toLogin()">登录</div>
          <div class="register" @click="register()">注册</div>
        </div>
        <div class="column-b-c">
          <div class="search">
            <svg t="1678167318773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="7041">
              <path
                d="M797.525333 752.266667c62.069333-72.736 97.28-165.002667 97.28-262.186667C894.816 266.528 713.621333 85.333333 490.08 85.333333 266.538667 85.333333 85.333333 266.538667 85.333333 490.069333 85.333333 713.610667 266.538667 894.826667 490.069333 894.826667a404.693333 404.693333 0 0 0 118.208-17.546667 32 32 0 0 0-18.666666-61.216 340.693333 340.693333 0 0 1-99.541334 14.762667C301.888 830.816 149.333333 678.261333 149.333333 490.069333 149.333333 301.888 301.888 149.333333 490.069333 149.333333 678.261333 149.333333 830.826667 301.888 830.826667 490.069333c0 89.28-35.381333 173.696-97.141334 237.322667a36.992 36.992 0 0 0 0.384 51.925333l149.973334 149.973334a32 32 0 0 0 45.258666-45.248L797.525333 752.266667z"
                p-id="7042" fill="#ffffff"></path>
            </svg>
          </div>
        </div>
        <div class="column-b-b">
          <div class="shoop">
            <img src="../../img/shoop1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cate_list } from '../../request/api'
export default {
  data() {
    return {
      columnShow: true,
      show: "register",
      tipsShow: false,
      mainNum: 0,
      ctshow: true,
      mainNum2: 0,
      ctshow: true,
      columnHoverShow: false,
      navigationList: [
        [
          {
            title: '正熙简介',
            path: 'Introduction'
          }, {
            title: '核心团队',
            path: 'Team'
          },
          {
            title: '联系方式',
            path: 'Contact'
          }, {
            title: '意见反馈',
            path: 'Opinion'
          },
        ], [

          {
            name: '一抗',
            path: 'Primary'
          }, {
            name: '二抗',
            path: 'Secondary'
          },
          {
            name: '同行对照',
            path: 'Homologous'
          }, {
            name: '重组蛋白',
            path: 'Recombinant'
          }, {
            name: '整段抗体',
            path: 'Whole'
          }
        ], [

          {
            title: '应用领域',
            path: 'APPlication'
          }, {
            title: '文献资料',
            path: 'Reference'
          },
          {
            title: '技术资料',
            path: 'Technical'
          }, {
            title: '视频课堂',
            path: 'Video'
          }
        ],
        [

          {
            title: '正熙公告',
            path: 'announcement'
          },
          {
            title: '行业资讯',
            path: 'industry'
          },
        ],
        [

          {
            title: '定制申请表',
            path: 'customize'
          }
        ],
        [

          {
            title: '积分商城',
            path: 'Mall'
          }, {
            title: '会员说明',
            path: 'Description'
          },
          {
            title: '隐私政策',
            path: 'Privacy'
          }, {
            title: '账号服务条款',
            path: 'Clause'
          }
        ],
        [
          {
            title: '招商代理',
            path: 'InvestmentAgent'
          }, {
            title: '人才招聘',
            path: 'TalentRecruitment'
          }
        ],
      ],
      footerList: [
        [

          {
            name: '积分商城',
            path: 'Mall'
          }, {
            name: '会员说明',
            path: 'Description'
          },
          {
            name: '隐私政策',
            path: 'Privacy'
          }, {
            name: '账号服务条款',
            path: 'Clause'
          }
        ],
        [{
          name: '付款方式',
          path: 'Termsofpayment'
        },
        {
          name: '购买流程',
          path: 'Purchaseprocess'
        },
        {
          name: '订单处理',
          path: 'Orderprocessing'
        },
        {
          name: '常见问题',
          path: 'Shoppingproblem'
        },],
        [
          {
            name: '配送说明',
            path: 'Distributioninstructions'
          },

          {
            name: '验货签收',
            path: 'Checkandreceive'
          },
          {
            name: '常见问题',
            path: 'Q&A'
          },
        ],
        [{
          name: '退还/换货',
          path: 'Returngoods'
        },
        {
          name: '退款说明',
          path: 'Refundinstructions'
        },
        {
          name: '发票说明',
          path: 'Invoicespecification'
        },
        {
          name: '售后联系方式',
          path: 'Aftersalescontact'
        },
        ],

      ]
    };
  },
  mounted() {
    cate_list({ type: 9 }).then((res) => {
      this.navigationList[1] = res.data.data

    })
  },
  methods: {
    click2(i) {
      this.$router.push('product')
      sessionStorage.setItem('product', JSON.stringify({ title: i }))
      this.$store.commit('saveCurrDbSource', { title: i })
      this.$emit("closeColumn", false)
      this.$emit('footer2')
    },
    click(val) {
      sessionStorage.setItem('getMenu', val.path)
      this.$router.push(val.path)
      this.$emit("closeColumn", false)
      this.$bus.$emit("hello", val.name)
      this.$emit('footer2')
    },
    tipsOut() {
      this.tipsShow = true
    },
    tipsLeave() {
      this.tipsShow = false
    },
    close() {
      this.$emit("closeColumn", false)
    },
    sub(event) {

      this.columnShow = false;
      this.mainNum = 1
    },
    main(event) {
      this.mainNum = 0

      this.columnShow = true;
    },
    toLogin() {
      this.show = "login";
      /*   this.$bus.$emit('registerEvent',this.show) */
      this.$router.push({ path: "/Login", query: { show: "toLogin" } });
    },
    //注册
    register() {
      this.show = "register";
      /*  this.$bus.$emit('registerEvent',this.show) */
      this.$router.push({ path: "/Login", query: { show: this.show } });
    },
    contraction(event) {
      this.mainNum2 = 0
      this.ctshow = true
    },
    expansion(event) {
      this.mainNum2 = 1
      this.ctshow = false
    },
    mainEnter() {
      this.columnHoverShow = true


    },
    mainLeave() {
      this.columnHoverShow = false
    },
    bannerEnter(n) {
      let column = document.querySelectorAll('.columnHover')[0]
      let column2 = document.querySelectorAll('.columnHover')[1]
      column.style.marginLeft = n * 4.3 + 'rem'
      column2.style.marginLeft = n * 4.3 + 'rem'
    }
  },
};
</script>

<style scoped>
.column-text span {
  font-family: Alibaba PuHuiTi-Medium;
}

.column-text p {
  font-family: Source Han Serif CN-Regular, Source Han Serif CN;
}

.column-banner {
  position: relative;
}

.columnHover {
  height: 100%;
  width: 4.3rem;

  backdrop-filter: blur(20px);
  background: rgba(20, 66, 151, 0.05);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
  transition: all .3s ease;
}

.column-b-b {
  margin-bottom: 0.25rem;
}

.column-menu-box {
  height: 2.89rem;
  display: flex;
  align-items: flex-end;
  margin-bottom: 0.25rem;
}

.c-t-c-b div:hover {
  cursor: pointer;
}

.column-banner-main {
  display: flex;

}

.column-banner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mainShow2 {
  color: #fff !important;
}

.mainShow2 .contraction {
  background: #fff;
}

.mainShow {
  color: #144297;
}

.column-menu-tips {
  position: absolute;
  top: -2.25rem;
  height: 2.25rem;
  width: 0.5rem;

}

.tips-container {
  margin-bottom: 0.25rem;
  height: 2rem;
  width: 0.5rem;
  border-radius: 0.5rem;
  background: #144297;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.column-phone svg:nth-child(1) {
  display: none;
}

.column-phone:hover svg:nth-child(1) {
  display: block;
}

.column-phone:hover svg:nth-child(2) {
  display: none;
}

.column-information svg:nth-child(1) {
  display: none;
}

.column-information:hover svg:nth-child(1) {
  display: block;
}

.column-information:hover svg:nth-child(2) {
  display: none;
}

.column-address svg:nth-child(1) {
  display: none;
}

.column-address:hover svg:nth-child(1) {
  display: block;
}

.column-address:hover svg:nth-child(2) {
  display: none;
}

.column-menu-tips svg {
  height: 0.3375rem;
  width: 0.3375rem;
}

.column-menu {
  position: relative;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 50%;
  background: #144297;
  display: flex;
  justify-content: center;
  align-items: center;
}

.column-menu:hover {
  cursor: pointer;
}

.quanbu {
  height: 0.25rem;
  width: 0.25rem;
}

.column-logo img {
  margin-top: 0.25rem;
  height: 1rem;
  width: 1rem;
}

.column-box {
  background: url(../../img/_20230331164705.jpg);
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
}

.column-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 1.25rem;
}

.column-title {
  padding-top: 2.7rem;
  width: 100%;
}

.column-title-container {
  padding-left: 0.3625rem;
  font-size: 0.175rem;
  color: #728ec1;

  position: relative;
}

.main-column {
  width: 100%;
  padding-bottom: 0.0875rem;
}

.xian {
  width: 100%;
  height: 1px;
  background: #144297;
  display: flex;
  align-items: center;
  justify-content: end;
}

.main-column:hover {
  cursor: pointer;
}

.sub-column {
  padding-top: 0.0875rem;
}

.sub-column {
  cursor: pointer;
}

.youxian {
  width: 100%;
  height: 1px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: start;
}

.youkuai {
  border: 2px solid #fff;
  height: 0;
  width: 0;
  transform: rotate(45deg);
  position: absolute;
  margin-left: -1px;
}

.title-square {
  border: 2px solid #144297;
  height: 0;
  width: 0;
  transform: rotate(45deg);
  position: absolute;
  margin-right: -1px;
}

.column-banner {
  display: flex;
}

.column-banner-main {
  width: 4.3rem;
  height: 100%;
  border-left: 1px solid #d9e3ef;
  z-index: 5;
  box-sizing: border-box;
}

.column-banner-container {
  padding-left: 1.35rem;
}

.column-text {
  color: #144297;

}

.column-text span {
  font-size: 0.4rem;
  font-weight: 500;
}

.column-text p {
  font-size: 0.2rem;
}

.c-t-c-b {
  padding-top: 1.4375rem;
  font-size: 0.225rem;
  color: #4368ac;
  height: 2.5rem;
}

.c-t-c-b div {
  margin-bottom: 0.2rem;
}

.column-banner-main:last-child {
  border-right: 1px solid #d9e3ef;
}

.column-right {
  height: 100%;
  background: linear-gradient(360deg, #144297 0%, #4368ac 100%);
  width: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.column-t {
  padding-top: 0.25rem;
  padding-left: 0.375rem;
}

.column-t-container {
  height: 0.5rem;
  width: 0.5rem;
  background: rgba(217, 227, 239, 0.4);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.column-t-container svg {
  height: 0.25rem;
  width: 0.25rem;
}

.column-t-container:hover {
  cursor: pointer;
}

.column-r {
  padding-right: 0.3125rem;
  padding-top: 3.5rem;

}

.c-t-c-b div {
  position: relative;
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
}

.c-t-c-b div::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background: #144297;
  border-radius: 50%;
  left: -10px;
  top: calc(50% - 2px);
  opacity: 0;
  -webkit-transition: opacity 0.5s cubic-bezier(0.34, 0.62, 0.4, 0.99);
  transition: opacity 0.5s cubic-bezier(0.34, 0.62, 0.4, 0.99);
}

.c-t-c-b div:hover::before {
  opacity: 1;
}

.c-t-c-b div:hover {
  color: #144297;
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
}

.column-r-t {
  display: flex;

  border-bottom: 1px solid #fff;
  font-size: 0.175rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  align-items: center;
  padding-left: 0.2125rem;
  padding-bottom: 0.0875rem;
}

.column-r-t div {
  height: 0.175rem;
  width: 0.175rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  color: #144297;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.0375rem;
}

.column-r-t:hover {
  cursor: pointer;
}

.column-r-b:hover {
  cursor: pointer;
}

.column-r-b {
  padding-top: 0.0875rem;
  display: flex;
  font-size: 0.175rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  align-items: center;
  padding-left: 0.2125rem;
}

.column-r-b div {
  height: 0.175rem;
  width: 0.175rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  color: #144297;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.0375rem;
}

.column-b {
  padding-left: 0.375rem;

}

.column-b-t {
  height: 1.3875rem;
  width: 0.5rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  font-size: 0.2rem;
  color: #fff;
  padding-bottom: 0.1rem;
}

.login {
  padding-top: 0.1rem;
  margin-left: 0.15rem;
  margin-right: 0.15rem;
  border-bottom: 1px solid #fff;
  padding-bottom: 0.075rem;
}

.login:hover {
  cursor: pointer;
}

.register:hover {
  cursor: pointer;
}

.register {
  padding-top: 0.075rem;
  margin-left: 0.15rem;
  margin-right: 0.15rem;
}

.column-b-c {
  padding-top: 0.25rem;
}

.search {
  height: 0.5rem;
  width: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search:hover {
  cursor: pointer;
}

.search svg {
  height: 0.2125rem;
  width: 0.2125rem;
}

.column-b-b {
  padding-top: 0.25rem;
}

.shoop {
  height: 0.5rem;
  width: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.shoop:hover {
  cursor: pointer;
}

.shoop img {
  height: 0.25rem;
  width: 0.25rem;
}
</style>


// WEBPACK FOOTER //
// src/components/column/column.vue